/*
 * DANYCARE — Newsletter-Anmeldung via Klaviyo Client-Subscribe API.
 * Meldet die E-Mail an der DOI-Liste an (data-list-id); Klaviyo verschickt die
 * Double-Opt-in-Mail, nach Bestätigung feuert der „Added to List“-Voucher-Flow.
 * Alle Texte kommen aus data-msg-* am Formular (sections/newsletter.liquid).
 */
(function () {
  var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';
  var REVISION = '2024-10-15';
  var EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

  function init(form) {
    if (form.__dcNlBound) return;
    form.__dcNlBound = true;

    var status = form.querySelector('[data-dc-newsletter-status]');
    var input = form.querySelector('input[type="email"]');
    var button = form.querySelector('button[type="submit"]');
    var companyId = form.dataset.companyId;
    var listId = form.dataset.listId;

    function show(msg, kind) {
      status.hidden = false;
      status.textContent = msg;
      status.classList.remove('dc-nl-form__message--success', 'dc-nl-form__message--error');
      status.classList.add(kind === 'success' ? 'dc-nl-form__message--success' : 'dc-nl-form__message--error');
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (input.value || '').trim();
      if (!EMAIL_RE.test(email)) {
        show(form.dataset.msgInvalid, 'error');
        input.focus();
        return;
      }
      button.disabled = true;

      fetch(ENDPOINT + '?company_id=' + encodeURIComponent(companyId), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: REVISION },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: form.dataset.source || 'Newsletter',
              profile: { data: { type: 'profile', attributes: { email: email } } }
            },
            relationships: { list: { data: { type: 'list', id: listId } } }
          }
        })
      })
        .then(function (res) {
          if (res.status === 202 || res.ok) {
            show(form.dataset.msgSuccess, 'success');
            input.disabled = true;
            button.hidden = true;
          } else {
            show(form.dataset.msgError, 'error');
            button.disabled = false;
          }
        })
        .catch(function () {
          show(form.dataset.msgError, 'error');
          button.disabled = false;
        });
    });
  }

  function boot() {
    var forms = document.querySelectorAll('form[data-dc-newsletter]');
    for (var i = 0; i < forms.length; i++) init(forms[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
